import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "value", "data-cy", "placeholder", "disabled", "required", "aria-required", "data-checkplz"]
const _hoisted_2 = ["name", "value", "data-cy", "placeholder", "disabled", "required", "aria-required"]
const _hoisted_3 = ["name", "value", "data-cy", "placeholder", "disabled", "required", "aria-required"]
const _hoisted_4 = ["name", "value", "data-cy", "placeholder", "disabled", "required", "aria-required"]
const _hoisted_5 = {
  for: "validatorAdresseVerwendenNein",
  class: "radiolabel"
}
const _hoisted_6 = { class: "address-vorschlaege" }
const _hoisted_7 = ["id", "value", "data-cy"]
const _hoisted_8 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_vorschlagsliste = _resolveComponent("vorschlagsliste")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_info_box = _resolveComponent("info-box")!
  const _component_Zelle = _resolveComponent("Zelle")!
  const _component_Zeile = _resolveComponent("Zeile")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.pruefen(false)), ["prevent"])),
      novalidate: ""
    }, [
      (_ctx.sichtbareFelder.includes('plz') || _ctx.sichtbareFelder.includes('ort'))
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 0,
            class: _normalizeClass(_ctx.zeileClass)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                breite: _ctx.titel?.breite,
                "ausrichtung-responsiv": _ctx.titel?.ausrichtungResponsiv,
                "zeige-info": _ctx.zeigeInfo,
                "info-box-id": "infoAdresse"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "plzOrtLabel", {}, () => [
                    _cache[24] || (_cache[24] = _createTextVNode("PLZ und Ort"))
                  ], true)
                ]),
                _: 3
              }, 8, ["breite", "ausrichtung-responsiv", "zeige-info"]),
              (_ctx.sichtbareFelder.includes('plz'))
                ? (_openBlock(), _createBlock(_component_zelle, {
                    key: 0,
                    breite: _ctx.plzFormat?.breite ? _ctx.plzFormat.breite : 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        autocomplete: "chrome-off",
                        type: "text",
                        name: _ctx.feldNamenNofill.plz,
                        value: _ctx.adresse.plz,
                        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updatePlz(_ctx.inputChangeHandler($event), true))),
                        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearUpdatePlz && _ctx.clearUpdatePlz(...args))),
                        onKeydown: [
                          _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.akzeptiereVorschlag(undefined)), ["enter"])),
                          _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.decVorschlag()), ["up"])),
                          _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.incVorschlag()), ["down"])),
                          _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.zeigeVorschlaegePlz = false), ["tab"]))
                        ],
                        onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loescheOrt())),
                        class: "c-form-control__input",
                        "data-cy": _ctx.feldNamen.plz,
                        placeholder: _ctx.placeholderPlz,
                        minlength: "5",
                        maxlength: "5",
                        min: "01001",
                        max: "99998",
                        disabled: _ctx.deaktivierteFelder.includes('plz'),
                        required: _ctx.required,
                        "aria-required": _ctx.required,
                        "aria-label": "Postleitzahl",
                        "data-checkplz": _ctx.adresse.zuPruefen,
                        "data-fehlermeldung": "Bitte geben Sie eine gültige Postleitzahl ein.",
                        ref: "plzInput"
                      }, null, 40, _hoisted_1),
                      _createVNode(_component_vorschlagsliste, {
                        vorschlaege: _ctx.adressVorschlaege,
                        anzeigen: _ctx.zeigeVorschlaegePlz,
                        selected: _ctx.selectedVorschlag,
                        onUpdate: _ctx.akzeptiereVorschlag
                      }, null, 8, ["vorschlaege", "anzeigen", "selected", "onUpdate"]),
                      (_ctx.zeigeFehler)
                        ? (_openBlock(), _createBlock(_component_validierungs_fehler, {
                            key: 0,
                            "fehler-text": _ctx.iFehler[_ctx.feldNamenNofill.plz]
                          }, null, 8, ["fehler-text"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["breite"]))
                : _createCommentVNode("", true),
              (_ctx.sichtbareFelder.includes('ort'))
                ? (_openBlock(), _createBlock(_component_zelle, {
                    key: 1,
                    breite: _ctx.ortFormat?.breite ? _ctx.ortFormat.breite : 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        autocomplete: "chrome-off",
                        type: "text",
                        name: _ctx.feldNamenNofill.ort,
                        value: _ctx.adresse.ort,
                        onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateOrt(_ctx.inputChangeHandler($event), true))),
                        onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearUpdateOrt && _ctx.clearUpdateOrt(...args))),
                        onKeydown: [
                          _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.akzeptiereVorschlag(undefined)), ["enter"])),
                          _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.decVorschlag()), ["up"])),
                          _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.incVorschlag()), ["down"])),
                          _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.zeigeVorschlaegeOrt = false), ["tab"]))
                        ],
                        class: "c-form-control__input",
                        "data-cy": _ctx.feldNamen.ort,
                        placeholder: _ctx.placeholderOrt,
                        minlength: "2",
                        maxlength: "40",
                        disabled: _ctx.deaktivierteFelder.includes('ort'),
                        required: _ctx.required,
                        "aria-required": _ctx.required,
                        "aria-label": "Ort",
                        "data-fehlermeldung": "Bitte geben Sie den Ort ein (max. 40 Zeichen).",
                        ref: "ortInput"
                      }, null, 40, _hoisted_2),
                      _createVNode(_component_vorschlagsliste, {
                        vorschlaege: _ctx.adressVorschlaege,
                        anzeigen: _ctx.zeigeVorschlaegeOrt,
                        selected: _ctx.selectedVorschlag,
                        onUpdate: _ctx.akzeptiereVorschlag
                      }, null, 8, ["vorschlaege", "anzeigen", "selected", "onUpdate"]),
                      (_ctx.zeigeFehler)
                        ? (_openBlock(), _createBlock(_component_validierungs_fehler, {
                            key: 0,
                            "fehler-text": _ctx.iFehler[_ctx.feldNamenNofill.ort]
                          }, null, 8, ["fehler-text"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["breite"]))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (_ctx.sichtbareFelder.includes('strasse') || _ctx.sichtbareFelder.includes('hausnummer'))
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 1,
            class: _normalizeClass(_ctx.zeileClass)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                breite: _ctx.titel?.breite,
                "ausrichtung-responsiv": _ctx.titel?.ausrichtungResponsiv
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "strasseHausnummerLabel", {}, () => [
                    _cache[25] || (_cache[25] = _createTextVNode("Straße und Hausnummer"))
                  ], true)
                ]),
                _: 3
              }, 8, ["breite", "ausrichtung-responsiv"]),
              (_ctx.sichtbareFelder.includes('strasse'))
                ? (_openBlock(), _createBlock(_component_zelle, {
                    key: 0,
                    breite: _ctx.strasseFormat?.breite ? _ctx.strasseFormat.breite : 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        autocomplete: "chrome-off",
                        type: "text",
                        name: _ctx.feldNamenNofill.strasse,
                        value: _ctx.adresse.strasse,
                        onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateStrasse(_ctx.inputChangeHandler($event), true))),
                        onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.clearUpdateStrasse && _ctx.clearUpdateStrasse(...args))),
                        onKeydown: [
                          _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.akzeptiereVorschlag(undefined)), ["enter"])),
                          _cache[16] || (_cache[16] = _withKeys(($event: any) => (_ctx.decVorschlag()), ["up"])),
                          _cache[17] || (_cache[17] = _withKeys(($event: any) => (_ctx.incVorschlag()), ["down"])),
                          _cache[18] || (_cache[18] = _withKeys(($event: any) => (_ctx.zeigeVorschlaegeStrasse = false), ["tab"]))
                        ],
                        class: "c-form-control__input",
                        "data-cy": _ctx.feldNamen.strasse,
                        placeholder: _ctx.placeholderStrasse,
                        minlength: "2",
                        maxlength: "60",
                        disabled: _ctx.deaktivierteFelder.includes('strasse'),
                        required: _ctx.required,
                        "aria-required": _ctx.required,
                        "aria-label": "Strasse",
                        "data-fehlermeldung": "Bitte geben Sie die Straße ein (max. 60 Zeichen).",
                        ref: "strasseInput"
                      }, null, 40, _hoisted_3),
                      _createVNode(_component_vorschlagsliste, {
                        vorschlaege: _ctx.adressVorschlaege,
                        anzeigen: _ctx.zeigeVorschlaegeStrasse,
                        selected: _ctx.selectedVorschlag,
                        onUpdate: _ctx.akzeptiereVorschlag
                      }, null, 8, ["vorschlaege", "anzeigen", "selected", "onUpdate"]),
                      (_ctx.zeigeFehler)
                        ? (_openBlock(), _createBlock(_component_validierungs_fehler, {
                            key: 0,
                            "fehler-text": _ctx.iFehler[_ctx.feldNamenNofill.strasse]
                          }, null, 8, ["fehler-text"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["breite"]))
                : _createCommentVNode("", true),
              (_ctx.sichtbareFelder.includes('hausnummer'))
                ? (_openBlock(), _createBlock(_component_zelle, {
                    key: 1,
                    breite: _ctx.hausnummerFormat?.breite ? _ctx.hausnummerFormat.breite : 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        autocomplete: "chrome-off",
                        type: "text",
                        name: _ctx.feldNamenNofill.hausnummer,
                        value: _ctx.adresse.hausnummer,
                        onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updateHausnummer(_ctx.inputChangeHandler($event)))),
                        onKeydown: _cache[20] || (_cache[20] = _withKeys(($event: any) => (_ctx.akzeptiereVorschlag(undefined)), ["enter"])),
                        class: "c-form-control__input",
                        "data-cy": _ctx.feldNamen.hausnummer,
                        style: _normalizeStyle(_ctx.hausnummerFormat?.style ? _ctx.hausnummerFormat.style : 'width:25%'),
                        placeholder: _ctx.placeholderHausnummer,
                        minlength: "1",
                        maxlength: "10",
                        disabled: _ctx.deaktivierteFelder.includes('hausnummer'),
                        required: _ctx.required,
                        "aria-required": _ctx.required,
                        "aria-label": "Hausnummer",
                        "data-fehlermeldung": "Bitte geben Sie die Hausnummer ein (max. 10 Zeichen).",
                        ref: "hausnummerInput"
                      }, null, 44, _hoisted_4),
                      (_ctx.zeigeFehler)
                        ? (_openBlock(), _createBlock(_component_validierungs_fehler, {
                            key: 0,
                            "fehler-text": _ctx.iFehler[_ctx.feldNamenNofill.hausnummer]
                          }, null, 8, ["fehler-text"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["breite"]))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_Zelle, { offset: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_info_box, {
                id: "infoAdresse",
                role: "tooltip",
                "aria-describedby": "infoAdresse",
                sichtbarkeit: _ctx.wechsleSichtbarkeit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.infoText), 1)
                ]),
                _: 1
              }, 8, ["sichtbarkeit"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 32),
    (_ctx.istSichtbar('modal-manuelleAdresse-' + _ctx.sessionMarker))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          titel: "Adressvorschlag",
          "hat-ja-nein-button": true,
          "schliessen-button-text": "Adresse bestätigen",
          onCloseModal: _ctx.schliesseManuelleAdresse,
          onCloseModalJa: _ctx.ubernehmeManuelleAdresse
        }, {
          inhalt: _withCtx(() => [
            _cache[27] || (_cache[27] = _createTextVNode(" Diese Adresse ist uns leider nicht bekannt: ")),
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, [
                _createTextVNode(_toDisplayString(_ctx.adresse.strasse) + " " + _toDisplayString(_ctx.adresse.hausnummer), 1),
                _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.adresse.plz) + " " + _toDisplayString(_ctx.adresse.ort), 1)
              ])
            ]),
            _cache[28] || (_cache[28] = _createTextVNode(" Wollen Sie sie dennoch verwenden? "))
          ]),
          _: 1
        }, 8, ["onCloseModal", "onCloseModalJa"]))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-verbesserungsVorschlag-' + _ctx.sessionMarker))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          titel: "Adressvorschlag",
          "hat-schliessen-button": true,
          "schliessen-button-text": "Adresse wählen",
          onCloseModal: _ctx.ubernehmeValidatorAdresse
        }, {
          inhalt: _withCtx(() => [
            _cache[33] || (_cache[33] = _createElementVNode("div", { style: {"padding-bottom":"1rem"} }, [
              _createElementVNode("strong", null, "Diese Adresse ist uns leider nicht bekannt"),
              _createTextVNode(", allerdings haben wir eine ähnliche Adresse gefunden."),
              _createElementVNode("br"),
              _createElementVNode("strong", null, "Bitte wählen Sie Ihre Adresse:")
            ], -1)),
            _createVNode(_component_zeile, null, {
              default: _withCtx(() => [
                _createVNode(_component_titel_zelle, { class: "address-vorschlag" }, {
                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                    _createTextVNode("Ursprüngliche Adresse:")
                  ])),
                  _: 1,
                  __: [29]
                }),
                _createVNode(_component_zelle, { class: "mkRadio" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.validatorAdresseVerwenden) = $event)),
                      type: "radio",
                      id: "validatorAdresseVerwendenNein",
                      name: "validatorAdresseVerwenden",
                      value: -1,
                      "aria-label": "Ursprüngliche Adresse",
                      "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                      "data-cy": "validatorAdresseVerwendenNein"
                    }, null, 512), [
                      [_vModelRadio, _ctx.validatorAdresseVerwenden]
                    ]),
                    _createElementVNode("label", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.adresse.strasse) + " " + _toDisplayString(_ctx.adresse.hausnummer), 1),
                      _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.adresse.plz) + " " + _toDisplayString(_ctx.adresse.ort), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_zeile, null, {
              default: _withCtx(() => [
                _createVNode(_component_titel_zelle, { class: "address-vorschlag" }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("Vorgeschlagene Adresse:")
                  ])),
                  _: 1,
                  __: [31]
                }),
                _createVNode(_component_zelle, { class: "mkRadio" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validatorAdresse, (option, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.validatorAdresseVerwenden) = $event)),
                            type: "radio",
                            id: 'ungepruefteAdresseVerwenden' + index,
                            name: "validatorAdresseVerwenden",
                            "aria-label": "Vorgeschlagene Adresse",
                            value: index,
                            "data-cy": 'ungepruefteAdresseVerwenden' + index
                          }, null, 8, _hoisted_7), [
                            [_vModelRadio, _ctx.validatorAdresseVerwenden]
                          ]),
                          _createElementVNode("label", {
                            for: 'ungepruefteAdresseVerwenden' + index,
                            class: "radiolabel"
                          }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(option.strasse) + " " + _toDisplayString(option.hausnummer), 1),
                              _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" " + _toDisplayString(option.plz) + " " + _toDisplayString(option.ort), 1)
                            ])
                          ], 8, _hoisted_8)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onCloseModal"]))
      : _createCommentVNode("", true)
  ], 64))
}